<p-toast styleClass="toast">
  <ng-template
    #message
    let-message
  >
    <div class="toast__content">
      @switch (message.severity) {
        @case ('success') {
          <svg
            class="toast__icon"
            icon="square-check"
          />
        }
        @case ('error') {
          <svg
            class="toast__icon"
            icon="warning"
          />
        }
      }
      <div class="toast__text-group">
        @if (message.summary) {
          <p class="toast__summary">{{ message.summary }}</p>
        }
        @if (message.detail) {
          <p class="toast__detail">{{ message.detail }}</p>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
